/**
 * src/api/tenants/index.ts — Exports publics du module tenants.
 *
 * Porte :
 *   - TenantsApi : façade principale (getMyTenant, listMyModules, isModuleEnabled,
 *                  getMyBranding, getMySettings, updateMyBranding, upsertMyBranding,
 *                  updateMySettings, listTenants, updateTenant, purgeOrphanTenant,
 *                  logAccountantEmailSend, listAccountantEmailSends)
 *   - Types publics (Tenant, TenantModules, ModuleSlug, ResellerBranding,
 *                    TenantSettings, TenantSettingsUpdate, TenantAccountantUpdate,
 *                    TenantAdminUpdate, AccountantEmailSend, PurgeOrphanTenantResult, etc.)
 *   - Helpers erreurs ré-exportés depuis src/api/errors
 *
 * Ce module dépend de src/api/users/UsersApi pour le contexte caller
 * (getMyTenantId, getMyTenantInfo sont dans UsersApi — ne pas dupliquer).
 */

// Façade API
export { TenantsApi } from './TenantsApi';

// Types publics
export type {
  Tenant,
  TenantRow,
  TenantInsert,
  TenantUpdate,
  TenantModules,
  TenantModulesRow,
  TenantModulesUpdate,
  ModuleSlug,
  ResellerBranding,
  ResellerBrandingRow,
  ResellerBrandingUpdate,
  ResellerBrandingInsert,
  TenantSettings,
  TenantSettingsUpdate,
  TenantAccountantUpdate,
  TenantAdminUpdate,
  AccountantEmailSend,
  AccountantEmailSendRow,
  AccountantEmailSendInsert,
  PurgeOrphanTenantResult,
} from './types';

// Helpers erreurs (évite un double import pour les consommateurs)
export type { AppError } from './errors';
export {
  appErrorFromSupabase,
  networkError,
  authError,
  validationError,
  notFoundError,
  supabaseError,
  unknownError,
} from './errors';

// Opérations admin plateforme (Strangler lot 4)
export { AdminOpsApi } from './AdminOpsApi';
export type {
  AppVersionRow,
  FeatureLockRow,
  TenantFeatureToggleRow,
  TenantErpConfigRow,
  TenantImportHistoryRow,
  UserPermissionRow,
  TenantDeviceRow,
  TenantDeviceOverrideRow,
  AssistanceAlertRuleRow,
  AssistanceAlertEventRow,
} from './AdminOpsApi';
